<template>
  <div>
    <FormFieldLabel v-if="label" :for="name">
      {{ label }}
    </FormFieldLabel>

    <div class="relative rounded-md">
      <input
        :id="name"
        :type="type"
        :name="name"
        :autocomplete="autocomplete"
        :class="[
          'block w-full rounded-md border border-background-fg/8 text-base font-semibold focus:outline-none', // Font size set at >14px (text-base) so no zoom on mobile when focused
          hasError
            ? 'border-error text-error placeholder:text-error focus:border-error focus:ring-error'
            : 'focus:border-primary focus:ring-primary',
        ]"
        :placeholder="placeholder"
        :value="inputValue"
        :aria-invalid="hasError"
        enterkeyhint="done"
        :disabled="disabled"
        :maxlength="maxlength"
        :pattern="pattern"
        :inputmode="inputmode"
        @input="handleChange"
        @blur="handleBlur"
      />
    </div>

    <template v-if="hasError">
      <p class="mt-1 text-xs font-medium text-error">
        {{ errorMessage }}
      </p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"
import type { HTMLAttributes } from "vue"

const props = withDefaults(
  defineProps<{
    type?: string
    name: string
    label: string
    placeholder?: string
    autocomplete?: string
    disabled?: boolean
    maxlength?: number
    pattern?: string
    inputmode?: HTMLAttributes["inputmode"]
  }>(),
  {
    type: "text",
    placeholder: "",
    autocomplete: undefined,
    disabled: false,
    maxlength: undefined,
    pattern: undefined,
  }
)

const name = toRef(props, "name")

const {
  value: inputValue,
  errorMessage,
  handleBlur,
  handleChange,
  meta,
} = useField(name)

const hasError = computed(() => {
  return meta.touched && !!errorMessage.value
})
</script>
